/**
 * vendorSlug.js
 *
 * Utilities for building and parsing human-readable vendor shop URLs.
 *
 * URL pattern:  /<prefix>/shop/<slug>--<mongoId>
 * Example:      /restaurant/shop/supu-foods-kampala--66a783c1a423d2985bb9b8a7
 *
 * Backwards-compatible: if the param contains no "--", the whole param is
 * treated as the raw MongoDB ID (existing links / bookmarks keep working).
 */

/**
 * Convert a vendor name into a URL-safe slug.
 * "Supu Foods & Kampala!" → "supu-foods-kampala"
 */
export function slugify(name) {
  if (!name || typeof name !== "string") return "shop";
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")   // strip accent marks
    .replace(/[^a-z0-9\s-]/g, " ")     // non-alphanumeric → space
    .trim()
    .replace(/\s+/g, "-")              // spaces → hyphens
    .replace(/-+/g, "-")               // collapse duplicate hyphens
    .slice(0, 60);                     // cap length
}

/**
 * Build the full route param string: "<slug>--<id>"
 * e.g.  buildVendorParam("Supu Foods", "66a783c1a423d2985bb9b8a7")
 *       → "supu-foods--66a783c1a423d2985bb9b8a7"
 */
export function buildVendorParam(name, id) {
  const slug = slugify(name);
  if (!slug || slug === "shop") return id;
  return `${slug}--${id}`;
}

/**
 * Extract the MongoDB ObjectId from a route param.
 * Handles both new "slug--id" and legacy plain-id formats.
 */
export function extractVendorId(param) {
  if (!param) return "";
  const sep = param.lastIndexOf("--");
  if (sep === -1) return param;          // legacy: no separator
  return param.slice(sep + 2);
}
